"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ChatBubble = function ChatBubble(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 25 25",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,0 C19.4035594,0 25,5.59644063 25,12.5 C25,14.8235321 24.3660382,16.9989945 23.2616512,18.8628503 L23.3710612,22.0086413 C23.3724643,22.0488614 23.3714382,22.0891295 23.3679884,22.1292259 C23.3206464,22.6794779 22.8362008,23.0871669 22.2859489,23.0398249 L22.2859489,23.0398249 L19.5749133,22.8065435 C17.5631758,24.1901407 15.1261643,25 12.5,25 C5.59644063,25 0,19.4035594 0,12.5 C0,5.59644063 5.59644063,0 12.5,0 Z M12.875,11 C11.8394661,11 11,11.8394661 11,12.875 C11,13.9105339 11.8394661,14.75 12.875,14.75 C13.9105339,14.75 14.75,13.9105339 14.75,12.875 C14.75,11.8394661 13.9105339,11 12.875,11 Z M18.875,11 C17.8394661,11 17,11.8394661 17,12.875 C17,13.9105339 17.8394661,14.75 18.875,14.75 C19.9105339,14.75 20.75,13.9105339 20.75,12.875 C20.75,11.8394661 19.9105339,11 18.875,11 Z M6.875,11 C5.83946609,11 5,11.8394661 5,12.875 C5,13.9105339 5.83946609,14.75 6.875,14.75 C7.91053391,14.75 8.75,13.9105339 8.75,12.875 C8.75,11.8394661 7.91053391,11 6.875,11 Z",
    id: "chatBubble"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#chatBubble"
  }));
};

var _default = ChatBubble;
exports["default"] = _default;
module.exports = exports["default"];